import type { ReactNode } from "react";
import { cn } from "@/lib/utils";

interface HigIconBadgeProps {
    children: ReactNode;
    className?: string;
    size?: "md" | "sm";
}

// Web HIG icon policy: thin monochrome symbols only, no emoji, no saturated icon chips.
export function HigIconBadge({ children, className, size = "md" }: HigIconBadgeProps) {
    return (
        <span
            className={cn(
                "inline-flex shrink-0 items-center justify-center rounded-[15px] bg-neutral-50 text-neutral-600 ring-1 ring-black/[0.05] shadow-[inset_0_1px_0_rgba(255,255,255,0.9)] dark:bg-neutral-800 dark:text-neutral-300 dark:ring-white/10 dark:shadow-[inset_0_1px_0_rgba(255,255,255,0.08)]",
                size === "md" ? "h-11 w-11 rounded-[14px]" : "h-8 w-8 rounded-[11px]",
                className,
            )}
        >
            {children}
        </span>
    );
}

export const higToolbarButtonClass =
    "inline-flex h-11 w-11 items-center justify-center rounded-[14px] bg-white/72 text-neutral-500 ring-1 ring-black/[0.05] shadow-[inset_0_1px_0_rgba(255,255,255,0.85)] transition-colors duration-150 hover:bg-white hover:text-neutral-700 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-brand-500 dark:bg-neutral-900/70 dark:text-neutral-400 dark:ring-white/10 dark:shadow-[inset_0_1px_0_rgba(255,255,255,0.06)] dark:hover:bg-neutral-900 dark:hover:text-neutral-200";